<template>
  <div class="location-picker">
    <div ref="map" class="map"></div>
  </div>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix für fehlende Marker-Icons (wichtig!)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: new URL(
    '../../assets/mapMarkers/marker-icon-2x-red.png',
    import.meta.url
  ).href,
  iconUrl: new URL(
    '../../assets/mapMarkers/marker-icon-red.png',
    import.meta.url
  ).href,
  shadowUrl: new URL(
    'leaflet/dist/images/marker-shadow.png',
    import.meta.url
  ).href
});

export default {
  name: 'LocationPicker',

  props:{
    positionExtern: Object,
    mapExpanded: Boolean,
    setMarkerActive: Boolean
  },
  data() {
    return {
      map: null,
      marker: null,
      position: null
    };
  },
  watch:{
    positionExtern: {
        async handler(newValue) {
          this.position = newValue;
          if (!newValue) return;
          const { lat, lng } = newValue;
          if (this.marker) this.marker.setLatLng([lat, lng]);
          else this.marker = L.marker([lat, lng]).addTo(this.map);

          this.map.setView([lat, lng], 16);

          await this.fetchAddress(lat, lng);
          this.$emit('locationSelected', {
            ...this.position,
            address: this.address
          });
        },
        immediate: true,
        deep: true
      },
      mapExpanded: {
        handler(newValue){
          if(newValue == false){
            this.map.setView([this.position.lat, this.position.lng], 16);
          } else{
            this.map.setView([this.position.lat, this.position.lng], this.map.getZoom());
          }
        }
      }
  },
  mounted() {
    // Karte initialisieren
    this.map = L.map(this.$refs.map).setView(
      [51.1657, 10.4515], // Deutschland
      6
    );

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap'
    }).addTo(this.map);

    // Klick-Event
    this.map.on('click', this.onMapClick);
  },

  methods: {
  async onMapClick(event) {
    if(!this.$props.setMarkerActive){
      return;
    }
    const { lat, lng } = event.latlng;

    this.position = {
      lat: Number(lat.toFixed(6)),
      lng: Number(lng.toFixed(6))
    };

    if (this.marker) {
      this.marker.setLatLng([lat, lng]);
    } else {
      this.marker = L.marker([lat, lng]).addTo(this.map);
    }

    await this.fetchAddress(lat, lng);
    console.log(this.address);
    this.$emit('locationSelected', {
      ...this.position,
      address: this.address
    });
  },

  async fetchAddress(lat, lng) {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`
      );
      const data = await response.json();

      this.address = {
        displayName: data.display_name,
        city:
          data.address.city ||
          data.address.town ||
          data.address.village ||
          '',
        postcode: data.address.postcode || '',
        street: data.address.road || '',
        country: data.address.country || '',
        house_number: data.address.house_number || '',
        county: data.address.county || ''
      };
    console.log(data);
    } catch (err) {
      console.error('Reverse Geocoding fehlgeschlagen', err);
      this.address = null;
    }
}

  }
};
</script>

<style scoped>
.location-picker {
  width: 100%;
}

.map {
  height: 320px;
  width: 100%;
  border-radius: 12px;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

.coords {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #333;
}
</style>
